import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../../types";
import { setUserToLocalStorage } from "../../../utils/functions/localStorageManager";
import classes from "./DiaryMatrix.module.scss";
import HeaderController from "../../matrix/organizms/HeaderController";
import DisplayArea from "../../matrix/displayArea/DisplayArea";
import { WorkerForMatrix } from "../../../types/dirary";
const DiaryMatrix = () => {
  const [user, setUser] = useRecoilState(userState);
  const [workerList, setWorkerList] = useState<WorkerForMatrix[]>([]);

  const [productNo, setProductNo] = useState(
    user.initialParameters.productNoForMatrix ?? ""
  );
  const [productBno, setProductBno] = useState(
    user.initialParameters.productBnoForMatrix ?? ""
  );
  useEffect(() => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          latestUrl: "/matrix",
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, []);
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <HeaderController
        workerList={workerList}
        setWorkerList={setWorkerList}
        productNo={productNo}
        setProductNo={setProductNo}
        productBno={productBno}
        setProductBno={setProductBno}
      />
      <DisplayArea
        productNo={productNo}
        setProductNo={setProductNo}
        productBno={productBno}
        setProductBno={setProductBno}
      />
    </Box>
  );
};

export default DiaryMatrix;
